import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { lazy, Suspense } from "react";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoadingAnimation from "@/components/LoadingAnimation";
import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";

// Lazy load route components for better bundle splitting
const DevelopmentProcess = lazy(() => import("@/pages/DevelopmentProcess"));
const About = lazy(() => import("@/pages/About"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Manufacturing = lazy(() => import("@/pages/Manufacturing"));
const Partnership = lazy(() => import("@/pages/Partnership"));

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: "spring" as const,
  stiffness: 400,
  damping: 30,
  mass: 0.8,
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <ErrorBoundary>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
          transition={pageTransition}
          className="w-full pointer-events-auto"
        >
          <Suspense fallback={<LoadingAnimation />}>
            <Routes location={location}>
              <Route path="/" element={<Index />} />
              <Route path="/development-process" element={<DevelopmentProcess />} />
              <Route path="/manufacturing" element={<Manufacturing />} />
              <Route path="/partnership" element={<Partnership />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </motion.div>
      </AnimatePresence>
    </ErrorBoundary>
  );
};

export default AnimatedRoutes;